<button
  class="btn"
  [type]="type"
  [ngClass]="[
    classes,
    variant === 'primary' ? 'btn-primary' : '',
    variant === 'theme' ? 'theme-light container-theme-light-icons' : '',
    variant === 'dark' ? 'theme-dark' : '',
    variant === 'danger' ? 'btn-danger' : '',
    variant === 'link' ? 'text-dark font-size-primary text-decoration-underline' : '',
  ]"
  [disabled]="disabled"
  [ngStyle]="customStyles"
>
  <i *ngIf="startIcon" class="icon fa mr-2" [ngClass]="startIcon"></i>
  <ng-content ></ng-content>
  <i *ngIf="endIcon" class="icon fa ml-2" [ngClass]="endIcon"></i>
</button>
